import { useAuthStore } from 'features/auth/stores/authStore';

import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';
import type { ApiResponse } from '../types/common.types';
import type { GetDashboardSummaryResult, GetDashboardTeamActivityResult } from '../types/dashboard.types';

const getWorkspaceId = (): string => {
  const workspaceId = useAuthStore.getState().user?.workspaceId;
  if (!workspaceId) throw new Error('No active workspace');
  return workspaceId;
};

export const dashboardService = {
  getSummary: (params: { from: string; to: string; userId?: string }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<GetDashboardSummaryResult>>(
      ENDPOINTS.DASHBOARD.SUMMARY(wid),
      { params },
    );
  },

  getTeamActivity: (params: { from: string; to: string; userId?: string }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<GetDashboardTeamActivityResult>>(
      ENDPOINTS.DASHBOARD.TEAM_ACTIVITY(wid),
      { params },
    );
  },
};
